<template>
    <span v-if="false"></span>
</template>
<!--
<script lang="ts">
import BaseDefMixin from "./BaseDefMixin.js";
export default {
    mixins: [BaseDefMixin],
    props: ["childIndex"],
};
</script>
-->
